module.exports = __webpack_public_path__ + "img/weixin.ca1d0381.png";